import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
     ContentRightWr,
     MainLeftTitle,
     CreateButton,
} from "../../../_uiComponents/WrapperComponents";
import ParticipantsManagementGrid from "./views/ParticipantsManagementGrid";


export default function ParticipantsManagementWrapper() {
     const navigate = useNavigate();
    
     return (
          <>
               <MainLeftTitle title="Participants Management">
                    <CreateButton
                         name="Add Participants"
                         onClick={() => navigate("/app/participant-data-manage/add")}
                    />
               </MainLeftTitle>

               <ParticipantsManagementGrid />
          </>
     );
}